module.exports = __webpack_public_path__ + "img/9791195752928.96845b6a.jpg";